/**
 * What the result pane can show for a finished design.
 *
 * Two independent facts decide this, and folding them together is what caused an `.svg` to flash
 * "PowerPoint files can't be previewed here" on its way to rendering:
 *
 *  - the FORMAT decides whether a preview is possible at all (a .pptx cannot be drawn here);
 *  - the FETCH decides whether we have the bytes yet, and it is a separate async step because the
 *    file sits behind the bearer guard.
 *
 * A condition of the shape `isVector && src` answers both at once, so "an SVG that has not loaded
 * yet" and "a PowerPoint file" become the same branch — and the user sees the wrong message every
 * single time, briefly, on a format the message does not apply to.
 */
export type DesignPreviewState = 'unsupported-format' | 'loading' | 'ready';

export function designPreviewState(input: {
  /** Whether the design is an SVG, the one format this pane can draw. */
  isVector: boolean;
  /** The resolved object URL, or null while the authed fetch is still in flight. */
  src: string | null;
}): DesignPreviewState {
  if (!input.isVector) return 'unsupported-format';
  return input.src ? 'ready' : 'loading';
}
